/**
 * Service for prescription scanning and saving operations
 */

/**
 * Scan prescription image using OCR
 * @param {File} imageFile - The prescription image file
 * @param {Function} sendRequest - The request function from useRequest hook
 * @returns {Promise<Object>} - Response with prescription data
 */
export const scanPrescription = async (imageFile, sendRequest) => {
    const formData = new FormData();
    formData.append('receipt', imageFile, imageFile.name);

    const response = await sendRequest({
        method: 'POST',
        url: '/module/basket/scanPrescription',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response;
};

/**
 * Save prescription details and image to backend
 * @param {Object} prescriptionData - Prescription scan results
 * @param {File} imageFile - The prescription image file
 * @param {Function} sendRequest - The request function from useRequest hook
 * @returns {Promise<Object>} - Response with saved prescription data
 */
export const savePrescription = async (prescriptionData, imageFile, sendRequest) => {
    const formData = new FormData();

    // Add prescription data fields
    formData.append('address_1', prescriptionData.scan_results.address_1 || '');
    formData.append('e_med_id', prescriptionData.scan_results.e_med_id || '');
    formData.append('expired_date', prescriptionData.scan_results.expired_date || '');
    formData.append('issued_date', prescriptionData.scan_results.issued_date || '');
    formData.append('name', prescriptionData.scan_results.name || '');
    formData.append('prescription_fee_exemption', prescriptionData.scan_results.prescription_fee_exemption || '');
    formData.append('rez_id', prescriptionData.scan_results.rez_id || '');
    formData.append('svnr', prescriptionData.scan_results.svnr || '');

    // Add the prescription image if available
    if (imageFile) {
        formData.append('prescriptionPicture', imageFile, imageFile.name);
    }

    const response = await sendRequest({
        method: 'POST',
        url: '/module/prescription/savePrescription',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response;
};
